import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { PageService } from '@vendasta/galaxy/page/src/page.service';
import { FALLBACK_BACK_URL } from '../../settings/constants';

@Component({
  selector: 'inbox-sticky-footer',
  imports: [CommonModule, RouterModule, MatCardModule, MatButtonModule, TranslateModule, GalaxyStickyFooterModule],
  templateUrl: './sticky-footer.component.html',
})
export class StickyFooterComponent {
  @Output() public submitClick = new EventEmitter<void>();
  @Input() public disabled = false;
  @Input() public submitOverride?: string;
  @Input() public cancelOverride?: string;

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly pageService = inject(PageService);
  onSubmit(): void {
    this.submitClick.emit();
  }

  back(): void {
    this.pageService.navigateToPrevious(FALLBACK_BACK_URL, this.route);
  }
}
